import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Modal from "@material-ui/core/Modal";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import axios from "axios";
import MaterialTable from "material-table";
import React, { useEffect } from "react";
import { Bar } from "react-chartjs-2";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#db7c68",
    padding: theme.spacing(1),
    fontStyle: "oblique",
    color: "aliceblue",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(10),
  },
  chart: {
    marginLeft: theme.spacing(2),
  },
  heading: {
    marginLeft: theme.spacing(2),
  },
  table: {
    width: 900,
    marginLeft: theme.spacing(2),
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#000000de",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    height: "94%",
    overflowY: "scroll",
    fontWeight: "bolder",
    fontFamily: "inherit",
  },
}));

function AdminDashboard(props) {
  {
    /*.............................................................|...............
  .........to store response having list of all booking types.....\|/..............
  .................................................................V...............*/
  }
  const [resp, setResp] = React.useState({});
  {
    /*......................................................|...............
  .........to store error response when getting list.......\|/..............
  ..........................................................V...............*/
  }
  const [errorResp, setErrorResp] = React.useState("");
  const classes = useStyles();
  {
    /*....................................|...............
  .........to store main chart data......\|/..............
  ........................................V...............*/
  }
  const [chartData, setchartData] = React.useState({});

  {
    /*....................................|...............
  .........to fetch main chart data......\|/..............
  ........................................V...............*/
  }
  const chart = () => {
    axios
      .get(
        "http://localhost:8002/eventRegistration/booking/viewTypeViseBooking/1"
      )
      .then((res) => {
        setResp(res.data);
        setchartData({
          labels: ["Self", "Group", "Corporate", "Others"], //.....categories of the chart.................................................
          datasets: [
            {
              label: "No. of registrations made", //...............text that comes on hover.................................................
              backgroundColor: [
                //.................................................colors of the bars.......................................................
                "#3e95cd",
                "#8e5ea2",
                "#3cba9f",
                "#e8c3b9",
              ],
              barThickness: 80,
              borderWidth: 5,
              data: [
                //................................................values for each bar......................................................
                res.data.self.length,
                res.data.group.length,
                res.data.corporate.length,
                res.data.other.length,
              ],
            },
          ],
        });
      })
      .catch((error) => {
        setErrorResp(error.response.data.message);
      });
  };

  {
    /*......................................................|...............
  .........to display self data on click of the bar........\|/..............
  ..........................................................V...............*/
  }
  const [displaySelfData, triggerSelfData] = React.useState(false);
  let selfData = []; //...........will be populated from backend response
  selfData = selfData.concat(resp.self);

  {
    /*......................................................|...............
  .........to display group data on click of the bar.......\|/..............
  ..........................................................V...............*/
  }
  const [displayGroupData, triggerGroupData] = React.useState(false);
  let groupData = []; //..........will be populated from backend response
  groupData = groupData.concat(resp.group);

  {
    /*......................................................|...............
  .........to display corporate data on click of the bar...\|/..............
  ..........................................................V...............*/
  }
  const [displayCorporateData, triggerCorporateData] = React.useState(false);
  let corporateData = []; //......will be populated from backend response
  corporateData = corporateData.concat(resp.corporate);

  {
    /*......................................................|...............
  .........to display others data on click of the bar......\|/..............
  ..........................................................V...............*/
  }
  const [displayOthersData, triggerOthersData] = React.useState(false);
  let othersData = [];
  othersData = othersData.concat(resp.other);

  const barClickHandler = (e) => {
    {
      /*...............................................................................|...............
    ........to populate values in object of self or group or corporate or others......\|/..............
    ...................................................................................V...............*/
    }
    if (e[0] !== undefined) {
      //.........................to handle if any bar shows any value to zero..........................
      let item = e[0];
      {
        /*......................................................|...............
    .........self or group or corporate or others............\|/..............
    ..........................................................V...............*/
      }
      let regType = item._model.label;
      if (regType === "Self") {
        triggerSelfData(true);
        triggerGroupData(false);
        triggerCorporateData(false);
        triggerOthersData(false);
      } else if (regType === "Group") {
        triggerGroupData(true);
        triggerSelfData(false);
        triggerCorporateData(false);
        triggerOthersData(false);
      } else if (regType === "Corporate") {
        triggerCorporateData(true);
        triggerSelfData(false);
        triggerGroupData(false);
        triggerOthersData(false);
      } else {
        triggerOthersData(true);
        triggerSelfData(false);
        triggerGroupData(false);
        triggerCorporateData(false);
      }
    }
  };
  {
    /*....................................|...............
  .........to open each row data.........\|/..............
  ........................................V...............*/
  }
  const [open, setOpen] = React.useState(false);
  {
    /*....................................|...............
  .........to show booking id on.........\|/..............
  .........on each row data...............V...............*/
  }
  const [useBookingId, setBookingId] = React.useState("");
  {
    /*.............................................|...............
  .........store booking details of each row......\|/..............
  .................................................V...............*/
  }
  const [bookingResp, setBookingResp] = React.useState({});
  {
    /*....................................|...............
  .........in case any error occur........|..............
  .........while retrieving booking......\|/...............
  .........details of each row............V...............*/
  }
  const [bookingErrorMsg, setBookingErrorMsg] = React.useState("");
  const handleOpen = (bid) => {
    //........................handle opening of each row data............
    setBookingId(bid);
    fetchBookingDetails(bid);
  };

  const handleClose = () => {
    //........................handle closing of each row data............
    setOpen(false);
  };

  {
    /*................................................|...............
  .........retrieve booking details for each row.....\|/..............
  ....................................................V...............*/
  }
  async function fetchBookingDetails(bid) {
    let url = `http://localhost:8002/eventRegistration/booking/viewBookingDetails/${bid}`;
    try {
      let res = await axios.get(url);
      setBookingResp(res.data);
      setOpen(true);
    } catch (error) {
      setBookingErrorMsg(error.response.data.message);
    }
  }
  useEffect(() => {
    chart();
  }, []);

  return (
    <React.Fragment>
      <Typography component="h1" variant="h4" className={classes.heading}>
        Welcome {props.adminResp.fullName}
      </Typography>
      <br />
      <Typography component="h1" className={classes.root}>
        Event #1
      </Typography>

      {/*................................................|...............
      .......................main bar chart.............\|/..............
      ...................................................V...............*/}
      <div
        className={classes.chart}
        style={{ position: "relative", width: 900, height: 450 }}
      >
        <Bar
          options={{
            tooltips: {
              mode: "index",
              intersect: false,
            },
            responsive: true,
            maintainAspectRatio: false,
            legend: { display: false },
            title: {
              display: true,
              text: "Total registrations made category wise",
              fontSize: 15,
            },
            scales: {
              yAxes: [
                {
                  minBarLength: 2,
                  ticks: {
                    display: true,
                    beginAtZero: true,
                    callback: function (value) {
                      if (Number.isInteger(value)) {
                        return value;
                      }
                    },
                    stepSize: 1,
                  },
                },
              ],
              xAxes: [
                {
                  ticks: {
                    padding: 1,
                    display: true,
                    beginAtZero: true,
                    stepSize: 1,
                  },
                },
              ],
            },
          }}
          onElementsClick={barClickHandler}
          data={chartData}
        />
      </div>
      {errorResp !== "" ? <div>{errorResp}</div> : null}
      {/*..................................................|...............
      .......................display self chart data......\|/..............
      .....................................................V...............*/}
      <span id="tables">
        {displaySelfData ? (
          <div className={classes.table}>
            <MaterialTable
              title="Self data"
              data={selfData}
              columns={[
                {
                  title: "Registration ID",
                  field: "bookingId",
                },
                { title: "Date", field: "bookingDate", type: "date" },
                { title: "Name", field: "fullName" },
              ]}
              options={{
                actionsColumnIndex: -1,
                headerStyle: {
                  backgroundColor: "#3e95cd",
                  color: "#FFF",
                },
              }}
              onRowClick={(evt, selectedRow) =>
                handleOpen(selectedRow.bookingId)
              }
            />
          </div>
        ) : null}
        {/*..................................................|...............
        .......................display group chart data.....\|/..............
        .....................................................V...............*/}
        {displayGroupData ? (
          <div className={classes.table}>
            <MaterialTable
              title="Group data"
              data={groupData}
              columns={[
                {
                  title: "Registration ID",
                  field: "bookingId",
                },
                { title: "Date", field: "bookingDate" },
                { title: "Name", field: "fullName" },
              ]}
              options={{
                actionsColumnIndex: -1,
                headerStyle: {
                  backgroundColor: "#8e5ea2",
                  color: "#FFF",
                },
              }}
              onRowClick={(evt, selectedRow) =>
                handleOpen(selectedRow.bookingId)
              }
            />
          </div>
        ) : null}
        {/*......................................................|...............
        .......................display corporate chart data.....\|/..............
        .........................................................V...............*/}
        {displayCorporateData ? (
          <div className={classes.table}>
            <MaterialTable
              title="Corporate data"
              data={corporateData}
              columns={[
                {
                  title: "Registration ID",
                  field: "bookingId",
                },
                { title: "Date", field: "bookingDate" },
                { title: "Name", field: "fullName" },
              ]}
              options={{
                actionsColumnIndex: -1,
                headerStyle: {
                  backgroundColor: "#3cba9f",
                  color: "#FFF",
                },
              }}
              onRowClick={(evt, selectedRow) =>
                handleOpen(selectedRow.bookingId)
              }
            />
          </div>
        ) : null}
        {/*..................................................|...............
        .......................display others chart data....\|/..............
        .....................................................V...............*/}
        {displayOthersData ? (
          <div className={classes.table}>
            <MaterialTable
              title="Others data"
              data={othersData}
              columns={[
                {
                  title: "Registration ID",
                  field: "bookingId",
                },
                { title: "Date", field: "bookingDate" },
                { title: "Name", field: "fullName" },
              ]}
              options={{
                actionsColumnIndex: -1,
                headerStyle: {
                  backgroundColor: "#e8c3b9",
                  color: "#FFF",
                },
              }}
              onRowClick={(evt, selectedRow) =>
                handleOpen(selectedRow.bookingId)
              }
            />
          </div>
        ) : null}
      </span>

      {/*...................................................|...............
      ...........box that displays details of each row.....\|/..............
      ......................................................V...............*/}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <h3 id="transition-modal-title">Registration Id: {useBookingId}</h3>{" "}
            <hr />
            {/*.................................................|...............
            .........check if received object is not empty.....\|/..............
            ....................................................V...............*/}
            {Object.keys(bookingResp).length > 1 ? (
              <React.Fragment>
                <div>
                  <span style={{ float: "left" }}>
                    {/*................................|...............
                    .........show booking details.....\|/..............
                    ...................................V...............*/}
                    <h5>
                      <b>
                        <u>Booking Details:</u>
                      </b>
                    </h5>
                    <br />
                    Booking Date:{" "}
                    <Typography color="primary">
                      {bookingResp.bookingDate.join("-")}
                    </Typography>
                    FullName of the person who made the booking:{" "}
                    <Typography color="primary">
                      {bookingResp.fullName.charAt(0).toUpperCase() +
                        bookingResp.fullName.slice(1)}
                    </Typography>
                    Gender:{" "}
                    <Typography color="primary">
                      {bookingResp.gender}
                    </Typography>
                    Email id:{" "}
                    <Typography color="primary">{bookingResp.email}</Typography>
                    Mobile Number:
                    <Typography color="primary">
                      {bookingResp.phoneNo}
                    </Typography>
                    Id Proof:
                    {bookingResp !== null ? (
                      <img
                        style={{ width: "40%" }}
                        src={bookingResp.idProof}
                      ></img>
                    ) : (
                      <div></div>
                    )}
                  </span>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  {/*...................................................|...............
                  ............check if multiple bookings exist.........\|/..............
                  ......................................................V...............*/}
                  {bookingResp.detailsOfPeople.length > 1 ? (
                    <span style={{ float: "right" }}>
                      <h5>
                        <b>
                          <u>Multiple bookings Details:</u>
                        </b>
                      </h5>
                      <br />
                      Total no. of tickets booked:
                      <Typography color="primary">
                        {bookingResp.noOfPeople}
                      </Typography>
                      {/*......................................|...............
                      ............loop over group members.....\|/..............
                      .........................................V...............*/}
                      {bookingResp.detailsOfPeople
                        .slice(0, -1)
                        .map((member, index) => (
                          <React.Fragment>
                            <Typography color="secondary">
                              Member # {index + 2}
                            </Typography>
                            Full Name:{" "}
                            <Typography color="primary">
                              {member.fullName.charAt(0).toUpperCase() +
                                member.fullName.slice(1)}
                            </Typography>
                            Gender:
                            <Typography color="primary">
                              {member.gender}
                            </Typography>
                            Mobile Number:{" "}
                            <Typography color="primary">
                              {member.phoneNo}
                            </Typography>
                            <br />
                          </React.Fragment>
                        ))}
                    </span>
                  ) : null}
                </div>

                <div style={{ display: "inline-block" }}>
                  {/*..............................|...............
                  .........show event details.....\|/..............
                  .................................V...............*/}
                  <h5>
                    <b>
                      <u>Event Details:</u>
                    </b>
                  </h5>
                  <br />
                  {/*.............................................................|...............
                  .........check if received object has event details or not.....\|/..............
                  ................................................................V...............*/}
                  {bookingResp.event !== undefined ? (
                    <React.Fragment>
                      Date of the event
                      <Typography color="primary">
                        {bookingResp.event.dateOfEvent.join("-")}
                      </Typography>
                      Event name:{" "}
                      <Typography color="primary">
                        {bookingResp.event.eventName}
                      </Typography>
                      Description:{" "}
                      <Typography color="primary">
                        {bookingResp.event.description}
                      </Typography>
                    </React.Fragment>
                  ) : null}
                </div>
              </React.Fragment>
            ) : null}
          </div>
        </Fade>
      </Modal>
    </React.Fragment>
  );
}

export default AdminDashboard;
